import React from 'react';
import { browserHistory } from 'react-router';
import * as actions from '../redux/actions';

class MainHeader extends React.Component {

  handleProfileClick(e) {
    e.preventDefault();
    browserHistory.push('/user/profile');
  }

  handleCommissionClick(e) {
    e.preventDefault();
    browserHistory.push('/commission');
  }

  handleLogout() {
    let { dispatch } = this.props;
    dispatch(actions.logoutUser()).then(() => {
      browserHistory.push('/logout');
    });
  }

  handleGetHostInfoList() {
    let { dispatch } = this.props;
    dispatch(actions.getHostInfoList(true, true)).then(console.log('Fired getHostInfoList()'));
  }

  render() {
    let {auth: {user}} = this.props;
    let email = user.email || '';
    // hide ability to add/remove host for front level support role
    let isFrontLevelSupport = user.isFrontLevelSupportRole();
    let isBasicSupport = user.isBasicSupportRole();
    let showCommissionLink = !(isFrontLevelSupport || isBasicSupport);

    return (
      <header className='nav-row pure-g'>
        <div className='pure-u-1-3 header-left'></div>
        <div className='pure-u-1-3'>
          <img
            className=''
            src='/img/dash-logo.png'
            style={{ margin: 15, height: 20 }}
            onDoubleClick={this.handleGetHostInfoList.bind(this)}
          />
        </div>
        <div className='pure-u-1-3 header-right'>
          {showCommissionLink && (
            <a className='commission' onClick={this.handleCommissionClick.bind(this)}>
              Assign Kiosk
            </a>
          )}
          {showCommissionLink && <span>|</span>}
          <a className='profile' onClick={this.handleProfileClick.bind(this)}>
            {email}
          </a>
          |
          <a className='logout' onClick={this.handleLogout.bind(this)}>
            Logout
          </a>
        </div>
      </header>
    );
  }
}

export default MainHeader;



// WEBPACK FOOTER //
// ./src/components/MainHeader.js